const labTests=
[    {symptom:"idAnaemia",
    displayAs: "Suspected ID Anaemia (click to check)",
    questionGroup: "labTestQuestions"
    },


    {symptom:"anaemia",
    displayAs: "Anaemia without evidence of iron deficiency",
    questionGroup: "labTestQuestions"
    },



    {symptom: "wcc",
    displayAs: "Elevated WCC",
    questionGroup: "labTestQuestions"
    },

    {symptom: "leukopenia",
    displayAs: "Leukopenia",
    questionGroup: "labTestQuestions"
    },

    {symptom:"thrombocytosis",
    displayAs:"Thrombocytosis",
    questionGroup: "labTestQuestions"
    },

    {symptom:"esr",
    displayAs:"Raised ESR or plasma viscosity",
    questionGroup: "labTestQuestions"
    },  
    
    {symptom: "hypercalcaemia",
    displayAs: "Hypercalcaemia",
    questionGroup: "labTestQuestions"
    }, 
    
    {symptom:"elevatedGlucose",
    displayAs:"High blood glucose",
    questionGroup: "labTestQuestions"
    },

    {symptom: "electrophoresis",
    displayAs: "Plasma electrophoresis suggests myeloma",
    questionGroup: "labTestQuestions"
    },

    {symptom: "bence",
    displayAs: "Bence–Jones protein urine test suggests myeloma",
    questionGroup: "labTestQuestions"
    },

    {symptom:"ca125",
    displayAs:"Ca125 35 or more",
    questionGroup: "labTestQuestions"
    },

    {symptom: "psa",
    displayAs: "PSA above ref for age",
    questionGroup: "labTestQuestions"
},

    {symptom:"fit",
    displayAs: "Positive FIT test",
    questionGroup: "fit"
    },

]



export default labTests